import IMask from 'imask';
import { clabe } from './clabe/clabe.es.js';
import { cnpj } from './cnpj/cnpj.es.js';
import { cpf } from './cpf/cpf.es.js';
import { date } from './date/date.es.js';
import { ssn } from './ssn/ssn.es.js';

/**
 * Map for pattern masks.
 */ const maskMap = {
    clabe,
    cnpj,
    cpf,
    date,
    ssn
};
const MaskOptions = Object.keys(maskMap);
const getMask = (mask)=>{
    if (!MaskOptions.includes(mask)) {
        throw new Error('Invalid input mask given.');
    }
    return new IMask.MaskedPattern({
        mask: maskMap[mask]
    });
};

export { getMask, maskMap };
//# sourceMappingURL=index.es.js.map
